import { useState } from "react";
import { API } from "@/lib/api";
import { streamChat } from "@/lib/chatStream";

const mkId = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : `msg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export function useChatSession(modes) {
  const [mode, setMode] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const startMode = (m) => {
    setMode(m);
    setMessages([{ id: mkId(), role: "ai", text: modes.find((x) => x.id === m).intro }]);
    setSessionId(null);
  };

  const resetMode = () => {
    setMode(null);
    setMessages([]);
    setSessionId(null);
  };

  const patchLastMessage = (text) =>
    setMessages((m) => {
      const next = [...m];
      next[next.length - 1] = { ...next[next.length - 1], text };
      return next;
    });

  const send = async (e) => {
    e?.preventDefault();
    if (!input.trim() || sending) return;
    const userText = input.trim();
    setInput("");
    setMessages((m) => [
      ...m,
      { id: mkId(), role: "user", text: userText },
      { id: mkId(), role: "ai", text: "" },
    ]);
    setSending(true);

    let acc = "";
    try {
      await streamChat({
        url: `${API}/chat`,
        body: { mode, message: userText, session_id: sessionId },
        onSession: (id) => setSessionId((cur) => cur || id),
        onDelta: (d) => {
          acc += d;
          patchLastMessage(acc);
        },
        onError: (err) => patchLastMessage(`Sorry — ${err}`),
      });
    } catch (err) {
      patchLastMessage(
        err?.message && err.message !== "Failed to fetch"
          ? `Sorry — I couldn't respond right now. (${err.message})`
          : "Network error. Please try again."
      );
    }
    setSending(false);
  };

  return { mode, messages, input, setInput, sending, startMode, resetMode, send };
}
